import gql from 'graphql-tag'

export default gql`
mutation deleteMedia($id: ID!) {
	cashAssist {
	  deleteMedia(id: $id) {
			id
		}
	}
}`

